export default __webpack_public_path__ + "static/media/inr_black.f32578fa.svg";